import axios from '@/utils/axios';

// Configuracao das impressoras no formato do app de impressao (exe) e monitor ao vivo.
const get = async (empresa_id) =>
  (await axios.get('/impressoras/config', { params: { empresa_id } })).data;

const salvar = async (empresa_id, impressora) =>
  (await axios.post('/impressoras/config', { empresa_id, impressora })).data;

const monitor = async (empresa_id) =>
  (await axios.get('/impressoras/monitor', { params: { empresa_id } })).data;

// Token do app de impressao: o exe acessa a API com ele, sem usuario/senha do banco.
const tokens = async (empresa_id) =>
  (await axios.get('/impressoras/tokens', { params: { empresa_id } })).data;

const gerarToken = async (empresa_id, descricao) =>
  (await axios.post('/impressoras/tokens', { empresa_id, descricao })).data;

const revogarToken = async (empresa_id, id) =>
  (await axios.post(`/impressoras/tokens/${id}/revogar`, { empresa_id })).data;

// Endereco da API que o exe deve usar (o mesmo do sistema web).
const urlApi = () => String(axios.defaults.baseURL || '').replace(/\/+$/, '');

export default { get, salvar, monitor, tokens, gerarToken, revogarToken, urlApi };
